class DesktopNavItem extends HTMLElement {
    constructor () {
        super();
        this.toggle = this.querySelector('.desktop-nav__toggle');
        this.dropdown = this.querySelector('.desktop-nav__dropdown');
        this.timeout = undefined;

        // Bind events to toggle
        // Touch and click events
        this.toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleMenu();
        });

        this.toggle.addEventListener('touchstart', (e) => {
            e.stopPropagation();
            this.toggleMenu();
        });

        this.dropdown.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        // Hover events (apply to both toggle and dropdown)
        this.addEventListener('mouseover', (event) => {
            if (!this.contains(event.relatedTarget)) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => this.toggleMenu(), 200);
            }
        });

        this.addEventListener('mouseout', (event) => {
            if (!this.contains(event.relatedTarget)) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => this.closeMenu(), 200);
            }
        });

        // Close menu when clicking outside
        document.addEventListener('click', (e) => {
            if (!this.contains(e.target)) {
                this.closeMenu();
            }
        });
    }

    toggleMenu () {
        const navBarItems = document.querySelectorAll('desktop-nav-item');
        const toggleBtn = this.toggle;
        const dropdownContainer = this.dropdown;
        const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
        // Handle accessibility first

        toggleBtn.setAttribute('aria-expanded', !isExpanded);
        dropdownContainer.setAttribute('aria-hidden', isExpanded);
        // Show / hide the dropdown
        toggleBtn.classList.toggle('active');
        dropdownContainer.classList.toggle('hidden');

        if (!isExpanded) {
            document.body.classList.add('nav-active');
        } else {
            document.body.classList.remove('nav-active');
        }
    }

    closeMenu () {
        const toggleBtn = this.toggle;
        const dropdownContainer = this.dropdown;
        // Handle accessibility first

        toggleBtn.setAttribute('aria-expanded', false);
        dropdownContainer.setAttribute('aria-hidden', true);
        // Hide the dropdown
        toggleBtn.classList.remove('active');
        dropdownContainer.classList.add('hidden');
        document.body.classList.remove('nav-active');
    }
}

customElements.define('desktop-nav-item', DesktopNavItem);
